export default body => (body ? JSON.stringify(body) : undefined);
